// DS: i2.19
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Folder: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3.5 6.23h9.74L12.1 4.75a2 2 0 0 0-.69-.55c-.26-.13-.55-.2-.84-.2H5.43c-.5-.01-.98.18-1.34.55-.36.36-.57.86-.59 1.38zm18 2.4c0-.62-.5-1.13-1.13-1.13H4.63C4 7.5 3.5 8 3.5 8.63v10.24c0 .62.5 1.13 1.13 1.13h15.75c.62 0 1.12-.5 1.12-1.13z"
      ></path>
    </svg>
  </IconWrap>
);
Folder.displayName = 'Folder';

export default Folder;
